<template>
    <!-- <v-parallax src="@/assets/verde.jpg"> -->
  
  
      <div class="mx-1 my-1">
        <v-btn style="font-size: 11px;" class="ma-2" color="black" variant="outlined" disabled>VER<v-icon color="blue" end icon="mdi-eye" disabled></v-icon></v-btn>
      <v-btn style="font-size: 11px;" class="ma-2" color="black" variant="outlined" disabled>Formulario Resarcimiento<v-icon color="red" end icon="mdi-alpha-r-circle" disabled></v-icon></v-btn>
           
        <v-card>
          <v-alert v-if="showAlert" type="success" title="Registrado !!!"
            text="Se ha registrado correctamente el Repuesto Pistola.">
            <v-icon @click="cerrarDialogo" class="m-1 position-absolute top-0 end-0" color="blue-lighten-5"
              icon="mdi-close-circle"></v-icon>
          </v-alert>
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" color="light-blue-darken-4" label="Buscar" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="registros" :search="search">
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon @click="abrirDialogo(item)" class="m-1" color="blue-lighten-2" icon="mdi-eye">
              </v-icon>
              <v-icon @click="abrirDialogo3(item)" class="m-1" color="red-darken-2" icon="mdi-alpha-r-circle">
              </v-icon>
  
            </template>
            <template v-slot:[`item.num`]="{ item }">
              {{ item.num }}
            </template>
          </v-data-table>
        </v-card>
        <v-dialog v-model="dialogoAbierto" max-width="500px">
          <v-card>
            <v-card-title> Contenido Individual </v-card-title>
            <v-card-text>
              <div><strong>ID: </strong> {{ id }}</div>
              <div><strong>NOMBRE_COMPLETO: </strong> {{ nombre_completo }}</div>
              <div><strong>CARNET: </strong> {{ carnet }}</div>
              <div><strong>DESCRIPCION: </strong> {{ descripcion }}</div>
              <div><strong>ORNAMENTO: </strong> {{ ornamento }}</div>
              <div><strong>VAINA: </strong> {{ vaina }}</div>
              <div><strong>GESTION DOTACION: </strong> {{ gestion_dotacion }}</div>
              <div><strong>PROCEDENCIA: </strong> {{ procedencia }}</div>
              <div><strong>OBSERVACIONES: </strong> {{ observaciones }}</div>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogoAbiertoResarcimiento" max-width="750px">
          <v-card>
            <v-card-title class="text-center"> REGISTRO CERTIFICADO RESARCIMIENTO SABLE </v-card-title>
            <v-card-text>
              <!-- Formulario para editar el nombre -->
              <v-form @submit.prevent="registraresarcimiento">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="carnet" label="Carnet" :rules="firstNameRules" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="codigo_persona" label="Codigo Persona" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-divider></v-divider>
                  <v-col cols="12" md="4">
                    <!-- <v-select v-model="tipo_certificado" :items="item_tipo_certificado" label="Certificdo"
                      :rules="lastNameRules"></v-select> -->
                      <v-text-field v-model="tipo_certificado" label="Certificado"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="gestion_certificado" label="Gestion" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <!-- <v-text-field v-model="grado" label="Grado" :rules="lastNameRules" disabled></v-text-field> -->
                    <v-select v-model="grado" :items="gradosselect" color="cyan-darken-1"
                      label="Grado"></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="nombre_completo" label="Nombre Completo" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="carnet" label="Carnet" :rules="lastNameRules" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="expedido" label="Expedido" :rules="lastNameRules" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="complemento" label="Complemento" :rules="lastNameRules" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="cuenta_mindef" label="Cuenta Mindef" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="registro_tesoreria" label="Registro Tesoreria"
                      :rules="lastNameRules"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="registro_rubro" label="Registro Rubro" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select v-model="cantidad" :items="item_cantidad" label="Cantidad" :rules="lastNameRules"></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <!-- <v-select v-model="descripcion" :items="item_descripcion" label="Descripcion"
                      :rules="lastNameRules"></v-select> -->
                      <v-text-field v-model="descripcion" label="Descripcion"
                      :rules="lastNameRules"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select v-model="tipo_documento" :items="item_tipo_documento" label="Tipo Documento"
                      :rules="lastNameRules"></v-select>
                      <!-- <v-text-field v-model="tipo_documento" label="Tipo Documento"
                      disabled></v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="codigo_dotacion" label="Codigo Dotacion" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="ornamento" label="Ornamento" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="vaina" label="Vaina" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select v-model="gestion_dotacion" :items="gestiones" :item-value="gestion_dotacion"
                      label="Gestion Dotacion" disabled></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="procedencia" label="Procedencia" :rules="lastNameRules" disabled></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="4">
                        <v-select v-model="estado" :items="estados" :item-value="estado" label="Estados" disabled></v-select>
                      </v-col> -->
                  <v-col cols="12" md="4">
                    <v-text-field v-model="observaciones" label="Observaciones" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                </v-row>
                 <v-col cols="12" md="4">
                      <v-text-field v-model="htd" label="HTD" :rules="lastNameRules"
                      ></v-text-field>
                    </v-col>
                <v-btn type="submit" block class="mt-2">Guardar Cambios</v-btn>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn variant="outlined" color="red" text @click="cerrarDialogo">Cerrar</v-btn>
            </v-card-actions>
  
          </v-card>
  
        </v-dialog>
      </div>
    <!-- </v-parallax> -->
  </template>
  
  <script>
  //import pdfMake from "pdfmake/build/pdfmake";
  //import pdfFonts from "pdfmake/build/vfs_fonts";
  import { defineComponent } from "vue";
  import ResarcimientosLista from "@/services/Resarcimientos";
  import { VDataTable } from "vuetify/labs/VDataTable";
  import Usuario from "@/services/Usuario";
  import ResarcimientoRegistro from "@/services/Resarcimientos";
  
  export default defineComponent({
    name: "AdminPage",
    components: {
      VDataTable,
    },
    data() {
      var registros;
      const personal = new ResarcimientosLista();
      return {
        id: null,
        carnet: "",
        gestion_certificado: '2024',
        cuenta_mindef: '1-24246087',
        registro_rubro: '15910',
        codigo_persona: "",
        nro_cuchillo: "",
        descripcion: "",
        marca: "",
        modelo: "",
        gestion_dotacion: "",
        grado:"",
        procedencia: "",
        observaciones: "",
        tipo_certificado: "RESARCIMIENTO",
        tipo_documento: "",
        cantidad: "",
        gradosselect:['Gral.','Cnl.','Tcnl.','My.','Cap.','Tte.','Sbtte','Sofs.','Sof.Mtre.','Sof.My.','Sof.1ro.','Sof.2do','Sof.Inc.','Sgto.1ro.','Sgto.2do.','Sgto.Inc.'],
        gestiones: ["2023", "2024", "2025", "2026", "2027", "2028"],
        //item_cantidad: ["1 (Una)", "1 (Un)", "2 (Dos)"],
        item_cantidad: ["1 (Un)"],
        //item_descripcion: ["Pistola", "Cargador de Pistola", "Cuchillo", "Sable Dorado", "Sable Palteado"],
        item_descripcion: ["Cuchillo"],
        //item_tipo_certificado: ["RESARCIMIENTO", "REPOSICIÓN"],
        item_tipo_documento: ["SABLE DORADO", "SABLE PLATEADO"],
        //item_tipo_documento: ["CUCHILLO"],
        registros,
        personal,
        search: "",
        headers: [
          {
            align: "center",
            key: "name",
            sortable: true,
          },
          { key: 'num', title: "#" },
          { key: "grado", title: "Grado" },
          { key: "nombre_completo", title: "Nombre Completo" },
          { key: "carnet", title: "Carnet" },
          { key: "descripcion", title: "#DESCRIPCION" },
          { key: "gestion_dotacion", title: "Gestion Dotacion" },
          { key: "actions", title: "Acciones", sortable: true, width: 150 },
        ],
        dialogoAbierto: false,
        showAlert: false,
        procedenciaList: [],
        dialogoAbiertoResarcimiento: false,
      };
    },
    methods: {
      cerrarDialogo() {
        this.dialogoAbierto = false;
        this.showAlert = false;
      },
      abrirDialogo(item) {
        if (item && item.id) {
          this.id = item.id;
          this.carnet = item.carnet;
          this.nombre_completo = item.nombre_completo;
          this.codigo_persona = item.codigo_persona;
          this.descripcion = item.descripcion;
          this.ornamento = item.ornamento;
          this.vaina = item.vaina;
          this.gestion_dotacion = item.gestion_dotacion;
          this.procedencia = item.procedencia;
          this.observaciones = item.observaciones;
          this.dialogoAbierto = true;
          this.htd = item.htd;
        }
      },
      abrirDialogo3(item) {
        if (item && item.codigo_dotacion) {
          this.codigo_dotacion = item.codigo_dotacion;
          this.carnet = item.carnet;
          this.grado = item.grado;
          this.expedido = item.expedido;
          this.complemento = item.complemento ?? " ";
          this.expedido = item.expedido;
          this.descripcion = item.descripcion;
          this.nombre_completo = item.nombre_completo;
          this.codigo_persona = item.codigo_persona;
          this.vaina = item.vaina;
          this.num_cargadores = item.num_cargadores;
          this.ornamento = item.ornamento;
          this.gestion_dotacion = item.gestion_dotacion;
          this.procedencia = item.procedencia;
          this.observaciones = item.observaciones;
          this.estado = item.estado;
          this.dialogoAbiertoResarcimiento = true;
          this.htd = item.htd;
        }
      },
      async registraresarcimiento() {
        try {
          const resarcimiento = new ResarcimientoRegistro();
          const pistolapost = {
            tipo_certificado: this.tipo_certificado,
            gestion_certificado: this.gestion_certificado,
            grado: this.grado,
            nombre_completo: this.nombre_completo,
            carnet: this.carnet,
            expedido: this.expedido,
            complemento: this.complemento,
            cuenta_mindef: this.cuenta_mindef,
            registro_tesoreria: this.registro_tesoreria,
            registro_rubro: this.registro_rubro,
            cantidad: this.cantidad,
            descripcion: this.descripcion,
            tipo_documento: this.tipo_documento,
            codigo_dotacion: this.codigo_dotacion,
            htd: this.htd,
          };
          const response = await resarcimiento.saveResarcimientoPistola(
            pistolapost
          );
          if (response.status === true) {
            console.log("Datos guardados exitosamente:", response);
            this.cerrarDialogo();
            this.showAlert = true;
          } else {
            console.error("Error al guardar los datos:", response);
            this.cerrarDialogo();
          }
        } catch (error) {
          console.error("Error en la función submitForm:", error);
        }
      },
    },
  
  
    async created() {
      //this.registros = await this.personal.listaresarcimientosget();
      this.registros = await this.personal.listaresarcimientossablegetaerea();
      //console.log("Estos son los registros",this.registros);
      this.registros.forEach((registro, index) => {
        registro.num = index + 1;
      });
      try {
        const firmasrol = new Usuario();
  
        // Obtener usuarios por el primer rol (roleId = 11)
        const roleId1 = 11;
        const response1 = await firmasrol.obtenerUsuariosPorRol(roleId1);
  
        console.log("Este es mi respuesta de Usuario para roleId1", response1);
  
        if (response1 && response1.length > 0) {
          const primerusuario1 = response1[0].nombres;
          console.log("Este es mi primerusuario para roleId1", primerusuario1);
          this.firma1 = primerusuario1;
          console.log("Esta es la firma para roleId1", this.firma1);
        } else {
          console.error(
            "La respuesta del servicio para roleId1 no contiene datos"
          );
        }
  
        // Obtener usuarios por el segundo rol (roleId = 12)
        const roleId2 = 12;
        const response2 = await firmasrol.obtenerUsuariosPorRol(roleId2);
  
        console.log("Este es mi respuesta de Usuario para roleId2", response2);
  
        if (response2.length > 0) {
          const primerusuario2 = response2[0].nombres;
          console.log("Este es mi primerusuario para roleId2", primerusuario2);
          this.firma2 = primerusuario2;
          console.log("Esta es la firma para roleId2", this.firma2);
        } else {
          console.error(
            "La respuesta del servicio para roleId2 no contiene datos"
          );
        }
      } catch (error) {
        console.error("Error al obtener usuarios por rol:", error);
      }
    },
  });
  </script>
  